import { render, staticRenderFns } from "./ChooseCountry.vue?vue&type=template&id=6285cdc9&"
import script from "./ChooseCountry.vue?vue&type=script&lang=ts&"
export * from "./ChooseCountry.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports